<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <default-heading class="mt-3">Products</default-heading>
    <div>
      <div class="my-4"></div>
      <!--      <b-card-->
      <!--        v-if="products.models && products.models.length"-->
      <!--        v-for="(product, index) in products.models"-->
      <!--        :key="index"-->
      <!--        img-width="200"-->
      <!--        :img-src="product.getImage()"-->
      <!--        :img-alt="'product-image-'+product.id"-->
      <!--        img-left-->
      <!--        class="mb-3">-->
      <!--        <b-card-text>-->
      <!--          <h3>-->
      <!--            <span>{{ product.name }}</span>-->
      <!--          </h3>-->
      <!--          <h5 class="float-right ml-2">{{ getProductValue(product) }}</h5>-->
      <!--          <div>{{ product.description }}</div>-->
      <!--          <h6 class="text-muted">{{ getAmountAvailable(product) }}</h6>-->
      <!--          <b-button v-if="isProductForSale(product)" class="float-right ml-2" variant="success" size="sm" @click="addToCart(product)">-->
      <!--            <i class="fal fa-cart-plus"></i> Add To Cart-->
      <!--          </b-button>-->
      <!--        </b-card-text>-->
      <!--      </b-card>-->
      <!--      <div v-if="!products.models || !products.models.length">-->
      <!--        <b-alert show>There are currently no products available.</b-alert>-->
      <!--      </div>-->
      <b-row
        class="align-self-stretch"
        v-if="products.models && products.models.length"
      >
        <b-col
          v-for="(product, index) in products.models"
          :key="index"
          cols="3"
          class="pb-4"
        >
          <b-card
            :img-src="product.images"
            :img-alt="'product-image-' + product.id"
            class="product-card h-100"
          >
            <b-card-title>
              {{ product.name }}
            </b-card-title>
            <div class="clearfix mb-3">
              <b-badge class="float-left"
                >Available: {{ getAmountAvailable(product) }}</b-badge
              >
              <b-badge class="float-right" variant="success">{{
                getProductValue(product)
              }}</b-badge>
            </div>
            <b-card-text>
              {{ product.description }}
            </b-card-text>
            <div class="clearfix">
              <b-button
                v-if="isProductForSale(product)"
                class="float-right"
                variant="success"
                @click="addToCart(product)"
              >
                <i class="fal fa-cart-plus"></i>
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { CART_ADD_PRODUCT } from "@/store/action-types";
import DefaultHeading from "../../components/shared/DefaultHeading";
import LoadingOverlay from "../../components/shared/LoadingOverlay";
import ProductCollection from "../../collections/cashier/ProductCollection";

export default {
  components: {
    LoadingOverlay,
    DefaultHeading
  },
  name: "ProductIndex",
  data() {
    return {
      loading: true,
      products: new ProductCollection()
    };
  },
  methods: {
    fetch() {
      let p1 = this.products.fetch();
      return Promise.all([p1]);
    },
    getAmountAvailable(product) {
      let sku = product.currentStockKeepingUnit();
      if (sku && +sku.inventory_quantity) {
        return +sku.inventory_quantity + " Available";
      }
      return "Out of stock";
    },
    getProductValue(product) {
      let sku = product.currentStockKeepingUnit();
      if (sku && +sku.price) {
        return "$" + Math.abs(+sku.price / 100).toFixed(2);
      }
      return "Price not listed";
    },
    isProductForSale(product) {
      let sku = product.currentStockKeepingUnit();
      if (sku && +sku.price && +sku.inventory_quantity) {
        return true;
      }
      return false;
    },
    addToCart(product) {
      this.$store.dispatch(CART_ADD_PRODUCT, { product });
    }
  },
  mounted() {
    this.loading = true;
    this.fetch().then(() => {
      this.loading = false;
    });
  }
};
</script>
<style>
.product-card {
  background-color: #e9e9e9;
}
.product-card img {
  width: 200px;
  margin: 0 auto;
}
.product-card .card-body {
  border-top: 1px solid #c8ced3;
  background-color: #fff;
}
</style>
